import { AuthCookieService } from './auth-cookie.service';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import {
    authLoadUser,
    authLogin,
    authLogout,
    authForgotPasswordRequest,
    authResetPassword,
    authSetPassword
} from './auth-store.actions';
import {
    getIsLoggedIn,
    getUser,
    getLogInErrorMessage,
    isLoading
} from './auth-store.selectors';
import { User, PostAuthDTO } from '@portal-front-end/models';
import { AuthPartialState } from './auth-store.reducer';

@Injectable({ providedIn: 'root' })
export class AuthStoreFacade {

    constructor(private store: Store<AuthPartialState>, private storage: AuthCookieService) { }
    
    user$: Observable<User> = this.store.pipe(
        select(getUser),
    );

    isLoggedIn$: Observable<boolean> = this.store.pipe(select(getIsLoggedIn));

    isLoading: Observable<boolean> = this.store.pipe(select(isLoading));

    logInErrMsg$: Observable<any> = this.store.pipe(select(getLogInErrorMessage));

    login(loginData: PostAuthDTO): void {
        this.store.dispatch(authLogin({ payload: loginData }));
    }

    forgotPasswordRequest(resetData: {email: string}): void {
        this.store.dispatch(authForgotPasswordRequest({ payload: resetData }));
    }

    resetPasswordRequest(resetData: {token: string, password: string}): void {
        this.store.dispatch(authResetPassword({ payload: resetData }));
    }

    logout(): Observable<void> {
        this.store.dispatch(authLogout());
        return of();
    }

    loadUser(isFromLogIn: boolean): void {
        this.store.dispatch(authLoadUser({ isFromLoginRequest: isFromLogIn }));
    }

    setPasswordRequest(passwordData: { token: string; password: string; }) {
        this.store.dispatch(authSetPassword({ payload: passwordData }));
    }
}
